module.exports = __webpack_public_path__ + "1f233dc5b8f9b496470b427de3301bbe.MP3";